import React from "react";

const DetailDescription = ({ course_desc, course_info }) => {
  course_desc =
    "Energetika muammolari instituti o‘zining ilmiy faoliyati davomida ko‘p yillik tarixga ega bo‘lib, O‘zbekiston Respublikasi energetika sohasidagi muhim tadqiqot muassasalaridan biri sifatida tanilgan. Ushbu institut O‘zbekiston Respublikasi Vazirlar Mahkamasining 2021-yil 4-maydagi 273-sonli qaroriga asosan tashkil etilgan. Institut sobiq O‘zbekiston Respublikasi Fanlar Akademiyasining Energetika va avtomatika instituti bazasida shakllantirilib, 2021-yil 4-maygacha faoliyat olib borgan “O‘zbekenergo” AJ Ilmiy-texnika markazi” MCHJning barcha vakolatlarini o‘z zimmasiga olgan holda O‘zbekiston Respublikasi Fanlar Akademiyasi tarkibida o‘z faoliyatini davom ettirdi. Institutning ilmiy faoliyati 1941-yilda tarqatib yuborilgan Suv va energetika muammolari institutining energetik ilmiy bo‘linmalari asosida boshlangan. Mazkur tarixiy asoslarga tayanib, Energetika muammolari instituti mamlakatning barqaror energetika rivojlanishi uchun strategik tadqiqotlar olib boruvchi asosiy muassasaga aylandi.";
  const researchDirections = [
    "Barqaror energetika rivojlanishi strategiyalari ishlab chiqish va yoqilg‘i-energetika majmuasining o‘rta hamda uzoq muddatli rivojlanish dasturlarini shakllantirish.",
    "Yoqilg‘i-energetika majmuasining dolzarb muammolarini tahlil qilish va global hamda mintaqaviy energetika rivojlanish tendensiyalarini o‘rganish.",
    "Muqobil energiya texnologiyalarini tadqiq etish, jumladan, resurs sig‘imdorligini tahlil qilish hamda iqlim sharoitlariga mos yangi uskunalarni ishlab chiqish.",
    "Energiya iste’molini kamaytirish bo‘yicha tavsiyalar ishlab chiqish va iqtisodiyotning turli tarmoqlarida energiya samaradorligini oshirish.",
    "Raqamli iqtisodiyot va “aqlli tarmoqlar” nazariyasini rivojlantirish, shuningdek, ushbu texnologiyalarni energetika sohasiga joriy qilish.",
    "Energetika xavfsizligini ta’minlash va favqulodda vaziyatlarda yoqilg‘i-energetika obyektlarining barqaror ishlashini tadqiq qilish.",
    "Qo‘shni davlatlar bilan yoqilg‘i-energetika resurslaridan foydalanish bo‘yicha ilmiy asoslangan tavsiyalar ishlab chiqish.",
    "An’anaviy, muqobil va qayta tiklanadigan energiya manbalari bo‘yicha innovatsion ishlanmalarni rivojlantirish va ushbu manbalarning iqtisodiy samaradorligini oshirish.",
  ];
  return (
    <div
      className="tab-pane fade show active"
      id="course-description"
      role="tabpanel"
      aria-labelledby="course-description-tab"
    >
      <div className="course-description">
        <h4 className="mb-4"> Ilmiy salohiyat va rivojlanish bosqichlari</h4>
        <p>{course_desc}</p>
        <h5>Ilmiy tadqiqotlarning asosiy yo‘nalishlari</h5>
        <p>
          Institutning ilmiy faoliyati keng ko‘lamli fundamental va amaliy
          tadqiqotlarni qamrab oladi:
        </p>
        <ul>
          {researchDirections.map((item, index) => (
            <li className="mb-2" key={index}>
              {item}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default DetailDescription;
